import { BaseModel } from './BaseModel';
import Cart from './Cart';
import LearningUnit from './LearningUnit';
import LearningUnitOption from './LearningUnitOption';
export class CartItem extends BaseModel {
  static get entity() {
    return 'cart_items';
  }

  static get fk() {
    return 'cart_item_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      learning_unit_id: this.attr(null),
      learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id'),
      mode: this.attr(null),
      is_selected: this.boolean(false),
      is_available: this.boolean(false),
      cart_id: this.attr(null),
      cart: this.belongsTo(Cart, 'cart_id'),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null),
      learning_unit_option_id: this.attr(null),
      learning_unit_option: this.belongsTo(LearningUnitOption, 'learning_unit_option_id'),
      available_modes: this.attr([])
    };
  }

  get isModeUnavaliable() {
    const { available_modes = [], mode } = this;

    return available_modes.indexOf(mode) === -1;
  }

  get hasAvailableModes() {
    const { available_modes = [] } = this;

    return available_modes.length > 0;
  }

  static apiConfig = {
    actions: {
      async fetch(params = {}) {
        return this.get(`/cart-items`, { params });
      },

      async fetchMyCartItem(params = {}, save = true) {
        return this.get(`/cart-items/my-cart`, { params, save });
      },

      async update(id, body = {}) {
        return this.put(`/cart-items/${id}`, body);
      },

      async updateEntry(id, { mode } = {}) {
        return this.put(`/cart-items/${id}`, { mode, option_type: 'ENTRY' });
      },

      async updateQuota(id, { mode } = {}) {
        return this.put(`/cart-items/${id}`, { mode, option_type: 'QUOTA' });
      },

      async deleteItem(id) {
        return this.delete(`/cart-items/${id}`, {
          save: false
        });
      },
      async fetchMyCart() {
        return this.get(`/carts/my-cart`);
      }
    }
  };
}

export default CartItem;
